import React, {useState} from 'react';
import {DeleteOutlined} from '@ant-design/icons';
import {Button, Popconfirm} from 'antd';
import {deleteD365ExpenseMapping} from "../../api/d365Api";

const RemoveMappingButton = ({ id, email, onCompleted }) => {
  const [loading, setLoading] = useState(false);

  const remove = async () => {
    try {
      setLoading(true)
      const response = await deleteD365ExpenseMapping(id, email);
      onCompleted(response, "remove");
    } catch (e) {
      console.error(`Could not remove mapping`);
    } finally {
      setLoading(false);
      onCompleted(null,"")
    }
  };

  return (
    <Popconfirm
      title={`Are you sure you want to remove this mapping (this cannot be undone)?`}
      onConfirm={remove}
      okText="Yes"
      cancelText="No"
    >
      <Button icon={<DeleteOutlined />} loading={loading}>Remove</Button>
    </Popconfirm>
  );
};

export { RemoveMappingButton };